import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CreatableSelect from "react-select/creatable";
import { useDispatch } from "react-redux";
import { InputError } from "../../../components/error/error";
import { sendEmail } from "../../../redux/sales/slice";

const SendMailModal = ({
  onClose,
  selectedSaleId,
  serviceData,
  setIsLoading,
  isLoading,
}) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{ emails: [] }}
      validationSchema={Yup.object().shape({
        emails: Yup.array()
          .min(1, "Please select an email or enter it manually")
          .of(
            Yup.object().shape({
              value: Yup.string()
                .email("Please enter a valid email")
                .required("Please enter a valid email"),
            })
          ),
      })}
      onSubmit={(values) => {
        setIsLoading(true);
        const payload = {
          ids: selectedSaleId,
          email: values.emails.length > 0 ? values.emails[0].value : "",
        };

        dispatch(sendEmail(payload)).then((res) => {
          setIsLoading(false);
          if (res.type === "sendEmail/fulfilled") {
            onClose();
          } else {
            setIsLoading(false);
          }
        });
      }}
    >
      {({ values, setFieldValue, errors, touched }) => (
        <Form>
          <div className="model" onClick={onClose}>
            <div
              className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="text-xl font-Montserrat mb-3 text-center font-normal">
                Send Service Report to:
              </h2>

              {/* Email Selection */}
              <div className="w-full mb-4">
                <CreatableSelect
                  className="w-full text-black p-0 font-Proxima"
                  id="email"
                  placeholder="Email"
                  options={
                    serviceData?.[0]?.company?.email
                      ? [
                          {
                            value: serviceData[0].company.email,
                            label: serviceData[0].company.email,
                          },
                        ]
                      : []
                  }
                  value={values.emails[0] || null}
                  onChange={(option) => setFieldValue("emails", [option])}
                  onCreateOption={(inputValue) => {
                    const newOption = { value: inputValue, label: inputValue };
                    setFieldValue("emails", [newOption]);
                  }}
                  formatCreateLabel={(inputValue) => `Send to "${inputValue}"`}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "1px solid #0000003B",
                      borderRadius: "0.3rem",
                      boxShadow: "none",
                      "&:hover": { border: "1px solid #0000003B" },
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected ? "#F15B29" : "white",
                      "&:active": {
                        backgroundColor: state.isSelected
                          ? "#F15B29"
                          : "rgba(0, 0, 0, 0.04)",
                      },
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                      marginTop: "2px",
                    }),
                  }}
                  menuPortalTarget={document.body}
                />
                {errors.emails && touched.emails ? (
                  <InputError
                    errorTitle={
                      Array.isArray(errors.emails)
                        ? errors.emails[0]?.value || errors.emails
                        : errors.emails
                    }
                  />
                ) : null}
              </div>

              {/* Action Buttons */}
              <div className="flex justify-center gap-4 pt-3">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-themeBtn flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                >
                  <span>Cancel</span>
                </button>
                <button
                  type="submit"
                  className="flex items-center justify-center px-6 py-1.5 font-Montserrat uppercase border-2 border-themeBtn rounded text-white bg-themeBtn"
                >
                  {isLoading ? "Loading" : "Send"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SendMailModal;
